import { render, staticRenderFns } from "./PatientMedicalPayments.vue?vue&type=template&id=9ec6a1c8&scoped=true&"
import script from "./PatientMedicalPayments.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalPayments.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicalPayments.vue?vue&type=style&index=0&id=9ec6a1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec6a1c8",
  null
  
)

export default component.exports